import { useLocation } from "react-router-dom";
import UseFetch from "../components/UseFetch";
import { useEffect, useState } from "react";
import EditePaieFacture from "../Ventes/EditePaieFacture";
import { decryptData } from "../components/const";
import EditePaieDette from "./EditePaieDette";
import EditeAvance from "./EditeAvance";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const CompteClient = () => {
    const location = useLocation();
    const { client } = location.state
    const { data: compteClient, isloading } = UseFetch(`client/${client.id}/compte`);

    const agent = compteClient?.client?.agent;
    const factures = compteClient?.factures?.sort((a, b) => (b.reste - a.reste));
    const paiements = compteClient?.paiements?.sort((a, b) => (b.id - a.id));
    const dettes = compteClient?.dettes;
    const remboursements = compteClient?.remboursements?.sort((a, b) => (b.id - a.id));
    const solde = compteClient?.solde;
    const versements = compteClient?.versements?.sort((a, b) => (b.id - a.id));

    const [index, setIndex] = useState(1);
    const [tabTrier, setTabTrier] = useState(null)
    // calcul total factures
    const [totalmontant, setTotalMontant] = useState(0);
    const [totalRemise, setTotalRemise] = useState(0);
    const [totalNet, setTotalNet] = useState(0);
    const [totalPaye, setTotalPaye] = useState(0);
    const [totalReste, setTotalReste] = useState(0);
    // calcul total dettes
    const [totalDette, setTotalDettes] = useState(0);
    const [totalDettePaye, setDettePaye] = useState(0);
    const [totalDetteReste, setDetteReste] = useState(0);
    // calcul total solde et avances
    const [totalAvance, setTotalAvance] = useState(0);
    const [selectPaie, setSelectPaie] = useState(null)
    const [tri, setTri] = useState('')



    const handlePrintClient = () => {
        if (!compteClient) return;

        const doc = new jsPDF("l", "pt");
        let y = 20;

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(`Grand Livre du Client : ${client?.client?.toUpperCase()}`, 20, y);
        y += 20;
        doc.setFontSize(10);
        doc.text(`Agent Responsable :  ${agent?.prenom} ${agent?.nom} `, 20, y);
        y += 20;
        doc.text(`Téléphone : ${client?.telephone}`, 20, y);
        y += 20;
        doc.text(`Crédit max : ${(client?.dettemax)} GNF`, 20, y);
        y += 20;
        doc.text(`Solde actuel : ${(compteClient?.solde)} GNF`, 20, y);
        y += 30;

        // --------------------- FACTURES ---------------------
        const factures = compteClient?.factures?.sort((a, b) => b.reste - a.reste) || [];
        if (factures.length > 0) {
            doc.setFontSize(12);
            doc.text("Liste des Factures", 20, y);
            y += 10;

            const totalMontant = factures.reduce((sum, f) => sum + f.total, 0);
            const totalRemise = factures.reduce((sum, f) => sum + f.remise, 0);
            const totalNet = factures.reduce((sum, f) => sum + f.montant, 0);
            const totalPaye = factures.reduce((sum, f) => sum + f.paye, 0);
            const totalReste = factures.reduce((sum, f) => sum + f.reste, 0);

            autoTable(doc, {
                startY: y,
                head: [["N°", "N°FACTURE", "MONTANT", "REMISE", "MONTANT NET", "PAYE", "RESTE", "VENDEUR", "MAGASIN", "DATE"]],
                body: factures.map((f, i) => [
                    i + 1,
                    f.numero,
                    (f.total),
                    (f.remise),
                    (f.montant),
                    (f.paye),
                    (f.reste),
                    f.vendeur?.toUpperCase(),
                    f.magasin?.toUpperCase(),
                    f.created_at
                ]),
                foot: [["TOTAUX", "", (totalMontant), (totalRemise), (totalNet), (totalPaye), (totalReste), "", "", ""]],
                styles: { fontSize: 9 },
                theme: "striped",
                headStyles: { fillColor: [41, 128, 185] },
                footStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
            });
            y = doc.lastAutoTable.finalY + 20;
        }

        // --------------------- PAIEMENTS FACTURES ---------------------
        const paiements = compteClient?.paiements?.sort((a, b) => b.id - a.id) || [];
        if (paiements.length > 0) {
            doc.setFontSize(12);
            doc.text("Liste des Règlements de Factures", 20, y);
            y += 10;

            const totalPaiements = paiements.reduce((sum, p) => sum + p.montant, 0);

            autoTable(doc, {
                startY: y,
                head: [["N°FACTURE", "MONTANT", "MAGASIN", "MODE PAIEMENT", "DATE"]],
                body: paiements.map(p => [
                    p.numero,
                    (p.montant),
                    p.magasin?.toUpperCase(),
                    p.source,
                    p.created_at
                ]),
                foot: [["TOTAL", (totalPaiements), "", "", ""]],
                styles: { fontSize: 9 },
                theme: "striped",
                headStyles: { fillColor: [41, 128, 185] },
                footStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
            });
            y = doc.lastAutoTable.finalY + 20;
        }

        // --------------------- DETTES ---------------------
        const dettes = compteClient?.dettes || [];
        if (dettes.length > 0) {
            doc.setFontSize(12);
            doc.text("Liste des Dettes Initiales", 20, y);
            y += 10;

            const totalDette = dettes.reduce((sum, d) => sum + d.dette, 0);
            const totalDettePaye = dettes.reduce((sum, d) => sum + d.paye, 0);
            const totalDetteReste = dettes.reduce((sum, d) => sum + d.reste, 0);

            autoTable(doc, {
                startY: y,
                head: [["MAGASIN", "DETTE INITIALE", "MONTANT PAYE", "RESTE A PAYER", "DATE DETTE"]],
                body: dettes.map(d => [
                    d.magasin?.toUpperCase(),
                    (d.dette),
                    (d.paye),
                    (d.reste),
                    d.date
                ]),
                foot: [["TOTAL", (totalDette), (totalDettePaye), (totalDetteReste), ""]],
                styles: { fontSize: 9 },
                theme: "striped",
                headStyles: { fillColor: [41, 128, 185] },
                footStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
            });
            y = doc.lastAutoTable.finalY + 20;
        }

        // --------------------- REMBOURSEMENTS ---------------------
        const remboursements = compteClient?.remboursements?.sort((a, b) => b.id - a.id) || [];
        if (remboursements.length > 0) {
            doc.setFontSize(12);
            doc.text("Liste des Remboursements de Dettes", 20, y);
            y += 10;

            const totalRemboursements = remboursements.reduce((sum, r) => sum + r.montant, 0);

            autoTable(doc, {
                startY: y,
                head: [["MAGASIN", "MONTANT PAYE", "DATE"]],
                body: remboursements.map(r => [
                    r.magasin?.toUpperCase(),
                    (r.montant),
                    r.created_at
                ]),
                foot: [["TOTAL", (totalRemboursements), ""]],
                styles: { fontSize: 9 },
                theme: "striped",
                headStyles: { fillColor: [41, 128, 185] },
                footStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
            });
            y = doc.lastAutoTable.finalY + 20;
        }

        // --------------------- VERSEMENTS / AVANCES ---------------------
        const versements = compteClient?.versements?.sort((a, b) => b.id - a.id) || [];
        if (versements.length > 0) {
            doc.setFontSize(12);
            doc.text("Liste des Versements / Avances", 20, y);
            y += 10;

            const totalVersements = versements.reduce((sum, v) => sum + v.montant, 0);

            autoTable(doc, {
                startY: y,
                head: [["MAGASIN", "MONTANT PAYE", "DATE"]],
                body: versements.map(v => [
                    v.magasin?.toUpperCase(),
                    (v.montant),
                    v.created_at
                ]),
                foot: [["TOTAL", (totalVersements), ""]],
                styles: { fontSize: 9 },
                theme: "striped",
                headStyles: { fillColor: [41, 128, 185] },
                footStyles: { fillColor: [200, 200, 200], fontStyle: "bold" },
            });
        }

        // --------------------- SAUVEGARDE ---------------------
        doc.save(`grand_livre_${client?.client}.pdf`);
    };

    useEffect(() => {
        if (!tabTrier) {
            setTabTrier(factures)
        }
    }, [factures])
    useEffect(() => {
        if (tri === 'tous') {
            setTabTrier(factures)
        }
        if (tri === 'payees') {
            setTabTrier(factures.filter((fact) => fact.reste === 0))
        }
        if (tri === 'impayees') {
            setTabTrier(factures.filter((fact) => fact.reste > 0))
        }
    }, [tri])



    useEffect(() => {
        setTotalMontant(tabTrier?.reduce((previous, current) => { return previous + current.total }, 0));
        setTotalRemise(tabTrier?.reduce((previous, current) => { return previous + current.remise }, 0));
        setTotalNet(tabTrier?.reduce((previous, current) => { return previous + current.montant }, 0));
        setTotalPaye(tabTrier?.reduce((previous, current) => { return previous + current.paye }, 0));
        setTotalReste(tabTrier?.reduce((previous, current) => { return previous + current.reste }, 0));
    }, [tabTrier])
    useEffect(() => {
        if (dettes?.length > 0) {
            setTotalDettes(dettes?.reduce((previous, current) => { return previous + current.dette }, 0));
            setDettePaye(dettes?.reduce((previous, current) => { return previous + current.paye }, 0));
            setDetteReste(dettes?.reduce((previous, current) => { return previous + current.reste }, 0));
        }
    }, [dettes]);
    useEffect(() => {
        setTotalAvance(versements?.reduce((previous, current) => { return previous + current.montant }, 0));
    }, [versements]);
    const user = decryptData("USER");
    return (
        <div className="compte">
            <div className="modal-footer p-0 justify-content-start align-items-center border-bottom pb-2 shadow mb-2 rounded">
                <button className="btn btn-primary mx-1" onClick={() => setIndex(1)}>Factures</button>
                <button className="btn btn-primary mx-1" onClick={() => setIndex(2)}>Dettes initiales</button>
                <button className="btn btn-primary mx-1" onClick={() => setIndex(3)}>Comptes et avances</button>
                <button className="btn btn-primary ms-auto" onClick={() => handlePrintClient()}> <div className="bx bx-printer"></div>  </button>
            </div>
            {
                isloading ?
                    <div className="loader"></div> :
                    <div className="row">
                        <div className="row my-3">
                            <h4 className="text-primary m-2"> DETAIL COMPTE CLIENT </h4>
                            <hr />
                            <div className="col-lg-6">
                                <div>  <span className="fw-bold mx-2">Client</span>: {client?.client?.toUpperCase()}</div>
                                <div><span className="fw-bold mx-2">Telephone</span>: {client?.telephone?.toUpperCase()}</div>
                                <div><span className="fw-bold mx-2">Credit max</span>: {client?.dettemax?.toLocaleString()} GNF</div>
                                <div><span className="fw-bold mx-2">Solde Actuel</span>: {solde?.toLocaleString()} GNF</div>
                            </div>
                            <div className="col-lg-6">
                                <div>  <span className="fw-bold mx-2">Agent responsable</span>: {`${agent?.prenom} ${agent?.nom}`}</div>
                                <div><span className="fw-bold mx-2">Telephone</span>: {agent?.telephone?.toUpperCase()}</div>
                            </div>
                        </div>
                        {index === 1 && <div className="factures">
                            <div className="row justify-content-between p-1 align-items-center">
                                <h4>LISTE DES FACTURES</h4>
                                <div className="d-flex align-items-center ms-auto w-auto">
                                    Afficher: <select name="tri" id="" className="form-select" onChange={(e) => setTri(e.target.value)}>
                                        <option value="tous">Tous</option>
                                        <option value="payees">Payees</option>
                                        <option value="impayees">Impayees</option>
                                    </select>
                                </div>
                            </div>
                            {
                                tabTrier?.length > 0 ?
                                    <div className="container mt-2-fluid">
                                        <div className="table-responsive mt-2">
                                            <table className="table table-striped table-hover table-bordered">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>N°</th>
                                                        <th>N°FACTURE</th>
                                                        <th>MONTANT</th>
                                                        <th>REMISE</th>
                                                        <th>MONTANT NET</th>
                                                        <th>PAYE</th>
                                                        <th>RESTE</th>
                                                        <th>VENDEUR</th>
                                                        <th>MAGASIN</th>
                                                        <th>DATE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tabTrier.map((fact, ind) => (
                                                            <tr key={ind} className={`align-middle ${fact?.suppression ? "bg-danger-subtle" : ""}`}>
                                                                <td>{ind + 1}</td>
                                                                <td>{fact.numero}</td>
                                                                <td>{fact.total.toLocaleString()}</td>
                                                                <td>{(+fact.remise).toLocaleString()}</td>
                                                                <td>{(+fact.montant).toLocaleString()}</td>
                                                                <td>{(+fact.paye).toLocaleString()}</td>
                                                                <td>{(+fact.reste).toLocaleString()}</td>
                                                                <td>{(fact.vendeur)?.toUpperCase()}</td>
                                                                <td>{(fact.magasin).toUpperCase()}</td>
                                                                <td>{fact.created_at}</td>

                                                            </tr>
                                                        ))
                                                    }
                                                    <tr className="table-secondary fw-bold " >
                                                        <td colSpan={2} className=" text-center ">TOTAUX </td>
                                                        <td>{(totalmontant)?.toLocaleString()} GNF</td>
                                                        <td>{(totalRemise)?.toLocaleString()} GNF </td>
                                                        <td>{(totalNet)?.toLocaleString()} GNF</td>
                                                        <td>{(totalPaye)?.toLocaleString()} GNF</td>
                                                        <td>{(totalReste)?.toLocaleString()} GNF</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <h5 className="mt-2">LISTE DES REGLEMENTS DE FACTURES</h5>
                                            {paiements.length > 0 ?
                                                <table className="table table-striped table-bordered">
                                                    <thead className="table-primary">
                                                        <tr>
                                                            <th>N°FACTURE</th>
                                                            <th>MONTANT</th>
                                                            <th>MAGASIN</th>
                                                            <th>MODE PAIEMENT</th>
                                                            <th>DATE</th>
                                                            {user.droit === "Magasin" && <th>ACTION</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            paiements?.map((paie, ind) => (
                                                                <tr key={ind}>
                                                                    <td>{paie.numero}</td>
                                                                    <td>{paie.montant?.toLocaleString()}</td>
                                                                    <td>{paie.magasin?.toUpperCase()}</td>
                                                                    <td>{paie.source}</td>
                                                                    <td>{paie.created_at}</td>
                                                                    {user.droit === "Magasin" && <td className="text-end">
                                                                        {paie.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editePaie' onClick={() => setSelectPaie(paie)}>
                                                                            <i className="bx bx-edit"></i>
                                                                        </button>
                                                                        }
                                                                    </td>}
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr className="table-secondary fw-bold " >
                                                            <td>TOTAL</td>
                                                            <td>{(totalPaye)?.toLocaleString()} GNF</td>
                                                        </tr>
                                                    </tbody>
                                                </table> : <div className="container mt-2 p-2 bg-danger-subtle text-danger text-center fs-5">Aucun paiement effectué par ce client</div>

                                            }
                                        </div>
                                    </div> : <div className="container mt-2 p-2 bg-danger-subtle text-danger text-center fs-5">Aucune facture pour ce client</div>
                            }
                        </div>}
                        {index === 2 && <div className="dettes">
                            {dettes.length > 0 ?
                                <div className="table-responsive">
                                    <h5 className="mt-2">LISTE DES DETTES INITIALES </h5>
                                    <table className="table table-striped table-bordered">
                                        <thead className="table-primary">
                                            <tr>
                                                <th>MAGASIN</th>
                                                <th>DETTE INITIALE</th>
                                                <th>MONTANT PAYE</th>
                                                <th>RESTE A PAYER</th>
                                                <th>DATE DETTE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dettes?.map((dette, ind) => (
                                                    <tr key={ind}>
                                                        <td>{dette.magasin?.toUpperCase()}</td>
                                                        <td>{dette.dette?.toLocaleString()}</td>
                                                        <td>{dette.paye?.toLocaleString()}</td>
                                                        <td>{dette.reste?.toLocaleString()}</td>
                                                        <td>{dette.date}</td>
                                                    </tr>
                                                ))
                                            }
                                            <tr className="table-secondary fw-bold " >
                                                <td className=" text-center ">TOTAUX </td>
                                                <td>{(totalDette)?.toLocaleString()} GNF</td>
                                                <td>{(totalDettePaye)?.toLocaleString()} GNF </td>
                                                <td>{(totalDetteReste)?.toLocaleString()} GNF</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    {remboursements.length > 0 ?
                                        <>
                                            <h5 className="mt-2">LISTE DES REMBOURSEMENTS DE DETTES </h5>
                                            <table className="table table-striped table-bordered">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>MAGASIN</th>
                                                        <th>MONTANT PAYE</th>
                                                        <th>DATE DETTE</th>
                                                        {user.droit === "Magasin" && <th>ACTION</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        remboursements?.map((remb, ind) => (
                                                            <tr key={ind}>
                                                                <td>{remb.magasin?.toUpperCase()}</td>
                                                                <td>{remb.montant?.toLocaleString()}</td>
                                                                <td>{remb.created_at}</td>
                                                                {user.droit === "Magasin" && <td className="text-end">
                                                                    {remb.duree < 2 && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editePaieDette' onClick={() => setSelectPaie(remb)}>
                                                                        <i className="bx bx-edit"></i>
                                                                    </button>
                                                                    }
                                                                </td>}
                                                            </tr>
                                                        ))
                                                    }
                                                    <tr className="table-secondary fw-bold " >
                                                        <td className=" text-center ">TOTAL </td>
                                                        <td>{(totalDettePaye)?.toLocaleString()} GNF </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </> : <div className="container mt-2 p-2 bg-danger-subtle text-danger text-center fs-5">Aucun remboursement effectué par ce client</div>

                                    }
                                </div> : <div className="container mt-2 p-2 bg-success-subtle text-success text-center fs-5">Ce client n'a pas de dette</div>

                            }
                        </div>}
                        {index === 3 &&
                            <div className="compte">
                                {
                                    <div className="table-responsive">
                                        {versements.length > 0 ?
                                            <>
                                                <h5 className="mt-2">LISTE DES VERSEMENTS </h5>
                                                <table className="table table-striped table-bordered">
                                                    <thead className="table-primary">
                                                        <tr>
                                                            <th>MAGASIN</th>
                                                            <th>MONTANT PAYE</th>
                                                            <th>MAGASIN</th>
                                                            <th>DATE</th>
                                                            {user.droit === "Magasin" && <th>ACTION</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            versements?.map((vers, ind) => (
                                                                <tr key={ind}>
                                                                    <td>{vers.magasin?.toUpperCase()}</td>
                                                                    <td>{vers.montant?.toLocaleString()}</td>
                                                                    <td>{vers.magasin?.toLocaleString()}</td>
                                                                    <td>{vers.created_at}</td>
                                                                    {user.droit === "Magasin" && <td className="text-end">
                                                                        {(vers.duree < 2 && vers.idmagasin === decryptData('user_profile').idmagasin) && <button className="btn btn-primary" data-bs-toggle='modal' data-bs-target='#editeAvance' onClick={() => setSelectPaie(vers)}>
                                                                            <i className="bx bx-edit"></i>
                                                                        </button>
                                                                        }
                                                                    </td>}
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr className="table-secondary fw-bold " >
                                                            <td className=" text-center ">TOTAL </td>
                                                            <td>{(totalAvance)?.toLocaleString()} GNF </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </> : <div className="container mt-2 p-2 bg-danger-subtle text-danger text-center fs-5">Aucun versement effectué par ce client</div>


                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
            }
            <EditePaieFacture paie={selectPaie} />
            <EditePaieDette paie={selectPaie} />
            <EditeAvance paie={selectPaie} />
        </div>
    );
}

export default CompteClient;